import { FormField } from '#client/components/ui/FormField';

interface ColorFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  helpText?: string | undefined;
}

/**
 * A colour a PDF can use.
 *
 * A native colour input, because it emits exactly the `#rrggbb` the template
 * schema accepts — a PDF has no `oklch()` and no `currentColor`, so the app's
 * own token colours are not candidates here. The hex is shown beside the swatch
 * so a lab can read a brand colour off one screen and type it into another.
 */
export function ColorField({ label, value, onChange, helpText }: ColorFieldProps) {
  return (
    <FormField label={label} helpText={helpText}>
      {({ id, describedBy }) => (
        <div className="c-color-field">
          <input
            id={id}
            type="color"
            className="c-color-field__swatch"
            value={value}
            aria-describedby={describedBy}
            onChange={(event) => onChange(event.target.value)}
          />
          <span className="c-color-field__value">{value}</span>
        </div>
      )}
    </FormField>
  );
}
